<template>
  <div
    id="home-page"
    class="h-full grid grid-rows-[auto_1fr] overflow-hidden relative"
  >
    <ThreadsNav :show-center="false">
      <template #right v-if="userStore.isLogin">
        <!-- <CrystalPowerCount /> -->
        <AddQQGroupBtn />
      </template>
    </ThreadsNav>
    <ThreadList
      ref="scroller"
      :on-pull-load="reload"
      :on-scroll-load="loadNextPage"
      @on-scroll="(h) => (height = h)"
      class="w-full"
    >
      <div class="h-full overflow-auto">
        <div class="overflow-hidden flex flex-col">
          <div class="red-dot ml-5 mr-2 flex items-center mb-2 justify-between">
            <div class="mr-2 font-semibold">{{ $t(`Titles.mymates`) }}</div>
            <div class="flex items-center gap-2">
              <button
                class="btn btn-xs rounded"
                @click="onMateItemClicked({ name: 'gallery' })"
              >
                <i class="iconify mingcute--photo-album-line"></i>
                {{ $t(`User.mate.module.gallery`) }}
              </button>

              <button
                class="btn btn-xs"
                @click="
                  userStore.isLogin
                    ? clickViewMode(
                        viewMode === 'avatar' ? 'portrait' : 'avatar'
                      )
                    : userStore.openLoginModal('register')
                "
              >
                <i
                  :class="[
                    'iconify',
                    viewMode === 'avatar'
                      ? 'pixelarticons--human-handsdown'
                      : 'mingcute--grid-line',
                  ]"
                ></i>
                {{
                  $t(
                    `User.mate.viewMode.${
                      viewMode === "portrait" ? "avatar" : "portrait"
                    }`
                  )
                }}
              </button>

              <button
                class="btn btn-xs"
                v-if="viewMode === 'avatar'"
                @click="
                  userStore.isLogin
                    ? (showOCSettings = true)
                    : userStore.openLoginModal('register')
                "
              >
                <i class="iconify mingcute--grid-line"></i>
              </button>
            </div>
          </div>

          <div>
            <div
              v-for="mate in mateStore.list"
              :key="mate.id"
              class="flex flex-col gap-1 flex-shrink-0 items-center relative overflow-hidden"
              @click="
                onMateItemClicked({
                  name: 'mateEdit',
                  params: { uuid: mate.uuid },
                })
              "
            ></div>
          </div>
          <!-- 立绘模式 -->
          <VanSwipe
            ref="swiper"
            v-if="viewMode === 'portrait'"
            class="relative"
          >
            <VanSwipeItem v-for="mate in mateStore.list" :key="mate.id">
              <img
                v-if="getPortraitUrl(mate)"
                :src="getPortraitUrl(mate)"
                alt=""
                @dragstart.prevent
                @mousedown="onMouseDown"
                @mouseup="onMouseUp($event, mate)"
                class="w-full h-full max-h-[70vh] object-contain"
              />

              <div
                v-else
                class="flex justify-center max-h-[70vh] overflow-hidden"
                @dragstart.prevent
                @mousedown="onMouseDown"
                @mouseup="onMouseUp($event, mate)"
              >
                <div class="">
                  <ImgPortraitPlaceholder
                    :style="{ height: portraitPlaceholderHeight }"
                    class="text-secondary"
                  />
                </div>
              </div>
              <div class="text-xs text-center mt-2">
                {{ useName(mate.name) }}
              </div>
            </VanSwipeItem>

            <template
              v-if="userStore.user.processingMateGenerationTaskIds?.length"
            >
              <VanSwipeItem
                v-for="taskId in userStore.user.processingMateGenerationTaskIds"
                :key="taskId"
              >
                <div
                  class="flex justify-center max-h-[70vh] overflow-hidden"
                  @dragstart.prevent
                >
                  <div class="relative">
                    <ImgPortraitPlaceholder
                      :style="{ height: portraitPlaceholderHeight }"
                      class="text-secondary opacity-30"
                    />

                    <MateCreateImgLoading
                      :allLoading="true"
                      :singleLoading="true"
                      :singlePercent="0"
                      :needWait="false"
                      :isFrameGenerating="true"
                    />
                  </div>
                </div>
                <div class="text-xs text-center mt-2">
                  {{ $t(`Message.generating`) }}
                </div>
              </VanSwipeItem>
            </template>

            <VanSwipeItem :key="0">
              <div
                class="flex flex-col gap-1 w-full"
                @mousedown="onMouseDown"
                @mouseup="onMouseUp($event)"
              >
                <div
                  class="aspect-[3/4] border-primary-content border-dashed rounded-lg flex justify-center items-center bg-neutral max-h-[70vh]"
                >
                  <div
                    class="w-[40%] aspect-[3/4] overflow-hidden flex items-center justify-center border border-dashed rounded-lg border-neutral-content"
                  >
                    <i
                      class="iconify mingcute--add-line text-neutral-content font-light w-[100%]"
                    />
                  </div>
                </div>
                <p class="text-xs text-center">{{ $t(`Buttons.add`) }}</p>
              </div>
            </VanSwipeItem>
            <template #indicator="{ active, total }">
              <div
                class="flex items-center justify-center w-10 h-10 absolute left-2 top-1/2 -translate-y-1/2 bg-base-100/80 backdrop-blur-sm rounded-full shadow-lg hover:bg-base-100/90 transition-all duration-200 cursor-pointer group"
                @click="swiper?.prev()"
              >
                <i
                  class="iconify mingcute--left-line text-xl text-base-content/70 group-hover:text-base-content transition-colors"
                ></i>
              </div>
              <div
                class="flex items-center justify-center w-10 h-10 absolute right-2 top-1/2 -translate-y-1/2 bg-base-100/80 backdrop-blur-sm rounded-full shadow-lg hover:bg-base-100/90 transition-all duration-200 cursor-pointer group"
                @click="swiper?.next()"
              >
                <i
                  class="iconify mingcute--right-line text-xl text-base-content/70 group-hover:text-base-content transition-colors"
                ></i>
              </div>

              <div
                class="absolute right-1 bottom-1 px-2 py-1 text-xs bg-black/10 rounded-full"
              >
                {{ active + 1 }}/{{ total }}
              </div>
            </template>
          </VanSwipe>

          <!-- 列表模式 -->
          <div
            v-else
            :class="[`grid gap-1 items-center flex-1 px-2`]"
            :style="`grid-template-columns: repeat(${lineMateCount}, 1fr);`"
            :key="lineMateCount"
          >
            <div class="flex flex-col gap-1 w-full" @click="clickCreateMate()">
              <div
                class="aspect-[3/4] border-primary-content border-dashed rounded-lg flex justify-center items-center bg-neutral"
              >
                <div
                  class="w-[40%] aspect-square overflow-hidden flex items-center justify-center border border-dashed rounded-full border-neutral-content"
                >
                  <i
                    class="iconify mingcute--add-line text-neutral-content font-light w-[80%]"
                  />
                </div>
              </div>
              <p class="text-xs text-center">{{ $t(`Buttons.add`) }}</p>
            </div>
            <div
              v-for="mate in mateStore.list"
              :key="mate.id"
              class="flex flex-col gap-1 flex-shrink-0 items-center relative overflow-hidden"
              @click="
                onMateItemClicked({
                  name: 'mateEdit',
                  params: { uuid: mate.uuid },
                })
              "
            >
              <div
                v-if="mate.isPreset"
                class="absolute top-0 right-0 badge badge-neutral z-[1] badge-xs text-[10px]"
              >
                {{ $t(`User.mate.preset`) }}
              </div>

              <div
                v-else-if="mate.status === 0"
                class="absolute top-0 right-0 badge badge-neutral z-[1] badge-xs text-[10px]"
              >
                {{ $t(`User.mate.draft`) }}
              </div>
              <UserAvatar :mate="mate" class="w-full" />
              <p class="text-xs line-clamp-1 w-full text-center">
                {{ useName(mate.name) }}
              </p>
            </div>
            <template
              v-if="userStore.user.processingMateGenerationTaskIds?.length"
            >
              <div
                v-for="taskId in userStore.user.processingMateGenerationTaskIds"
                :key="taskId"
                class="flex flex-col gap-1 flex-shrink-0 items-center relative overflow-hidden"
              >
                <div class="w-full relative">
                  <ImgAvatarPlaceholder
                    class="text-secondary opacity-30 aspect-[3/4]"
                  />
                  <MateCreateImgLoading
                    :allLoading="true"
                    :singleLoading="true"
                    :singlePercent="0"
                    :needWait="false"
                    :isFrameGenerating="true"
                    size="loading-md"
                  />
                </div>
                <p class="text-xs line-clamp-1 w-full text-center">
                  {{ $t(`Message.generating`) }}
                </p>
              </div>
            </template>
          </div>
        </div>

        <div
          class="red-dot flex items-center mb-2 mt-4 ml-5 justify-between mr-2"
        >
          <div class="mr-2 font-semibold">{{ $t(`adoption.adopt`) }}</div>

          <div class="flex gap-1">
            <button
              class="btn btn-xs rounded"
              @click="
                onMateItemClicked({
                  name: 'adoptionHome',
                  query: {
                    type: 'myAdoption',
                  },
                })
              "
            >
              {{ $t(`adoption.myAdoption`) }}
            </button>
            <button
              class="btn btn-xs rounded btn-primary"
              @click="
                onMateItemClicked({
                  name: 'adoptionCreate',
                })
              "
            >
              {{ $t("adoption.publishAdoption") }}
            </button>
          </div>
        </div>
        <mate-adoption-waterfall :list="list" activeTab="adoptable" />
      </div>
    </ThreadList>

    <VanPopup v-model:show="showOCSettings" position="top">
      <div class="p-4 flex flex-col gap-5">
        <div class="flex flex-col gap-2">
          <div>{{ $t(`setting.lineMateCount`) }}</div>
          <div class="flex items-center justify-between gap-5">
            <div>3</div>
            <van-slider
              v-model="lineMateCount"
              @change="onLineMateCountChange"
              :min="3"
              :max="10"
              :step="1"
              :disabled="viewMode === 'portrait'"
            >
              <template #button>
                <div class="btn btn-xs btn-primary">{{ lineMateCount }}</div>
              </template>
            </van-slider>
            <div>10</div>
          </div>
        </div>
      </div>
    </VanPopup>
  </div>
</template>

<script setup lang="ts">
import { readMateAdoptionExplorePage } from "@/apis/mate";
import ThreadList, {
  ThreadListInstance,
} from "@/components/mobile/ThreadList.vue";
import { useGlobalModal } from "@/stores/globalModal";
import { useGlobalUser } from "@/stores/globalUser";
import { useMate } from "@/stores/mate";
import { Mate, MateAdoption } from "@/types/entity";
import { useName, usePreviewImg } from "@/use/common";
import { pollMateGenerationTask } from "@/views/Mate/Create/MateCreateTask";
import { showConfirmDialog, SwipeInstance } from "vant";
import { onActivated, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { RouteLocationRaw, useRouter } from "vue-router";

const userStore = useGlobalUser();
const mateStore = useMate();
const router = useRouter();
const swiper = ref<SwipeInstance>();
const { t } = useI18n();

const lineMateCount = ref(3);
const viewMode = ref<"avatar" | "portrait">("avatar");

const clickViewMode = (mode: "avatar" | "portrait") => {
  viewMode.value = mode;
  userStore.updateUserExtraConfig({ viewMode: mode });
};

const onLineMateCountChange = (value: number) => {
  lineMateCount.value = value;
  userStore.updateUserExtraConfig({ lineMateCount: value });
};

const onMateItemClicked = async (to: RouteLocationRaw) => {
  if (!userStore.isLogin) return userStore.openLoginModal("register");

  router.push(to);
};

const getPortraitUrl = (mate: Mate) => {
  if (!mate.spritezz?.length) return "";

  let defaultSprite = mate.spritezz?.find((v) => v.isDefault);
  if (!defaultSprite) defaultSprite = mate.spritezz![0];
  if (!defaultSprite.portraitMedia?.url) return "";

  return usePreviewImg(defaultSprite!.portraitMedia!.url);
};

const showOCSettings = ref(false);

const list = ref<MateAdoption[]>([]);
const scroller = ref<ThreadListInstance>();

const reload = async () => {
  list.value = [];
  if (userStore.isLogin) mateStore.fetchMateList();
  scroller.value?.resetScrollLoadingState();
};

const loadNextPage = async () => {
  const { length } = list.value;
  if (length !== 0 && length % 10 !== 0) return false;

  const page = length / 10 + 1;
  const res = await readMateAdoptionExplorePage({
    filter: { status: 1 },
    pagination: { page, perPage: 10 },
  });
  list.value = [...list.value, ...res!.page.data];

  return res!.page.data.length === 10;
};

const modalStore = useGlobalModal();
const clickCreateMate = async () => {
  if (!userStore.isLogin) return userStore.openLoginModal("register");
  modalStore.openCustomGlobalActionSheet({
    title: t(`Message.howToGetMate`),
    list: [
      {
        content:
          "<i class='iconify mingcute--add-line'></i> " +
          t(`MineMate.mode.easy`),
        className: "btn-primary",
        callback: async () => {
          onMateItemClicked({
            name: "mateCreateAuto",
          });
        },
      },
      // {
      //   content:
      //     "<i class='iconify pixelarticons--human-handsdown'></i> " +
      //     t(`MineMate.mode.preset`),
      //   callback: () => {
      //     onMateItemClicked({
      //       name: "mateCreate",
      //       query: {
      //         isPreset: 1,
      //         mateType: MateType.Fanswork,
      //       },
      //     });
      //   },
      // },
      {
        content:
          "<i class='iconify proicons--box'></i> " +
          t(`MineMate.mode.driftCapsule`),
        callback: () => {
          mateStore.clickEnterDriftCapsule();
        },
      },
      {
        content:
          "<i class='iconify mingcute--grid-line'></i> " +
          t(`MineMate.mode.ocEditor`),
        callback: async () => {
          if (mateStore.list.some((v) => !v.name)) {
            try {
              await showConfirmDialog({
                message: t(`Message.unNamedMate`),
                confirmButtonText: t(`Buttons.yes`),
                cancelButtonText: t(`Buttons.no`),
              });
            } catch {
              return;
            }
          }
          mateStore.clickCreateMate();
        },
      },
    ],
  });
};

const height = ref(0);

let startPosition = { x: 0, y: 0 };
const onMouseDown = (event: MouseEvent) => {
  startPosition = { x: event.clientX, y: event.clientY };
};

const onMouseUp = (event: MouseEvent, mate?: Mate) => {
  const distance = {
    x: event.clientX - startPosition.x,
    y: event.clientY - startPosition.y,
  };

  if (Math.abs(distance.x) < 10 && Math.abs(distance.y) < 10) {
    mate
      ? onMateItemClicked({
          name: "mateEdit",
          params: { uuid: mate.uuid },
        })
      : clickCreateMate();
  }
};

const portraitPlaceholderHeight = ref(0);

const initUserIfHasTask = async () => {
  await userStore.refresh();

  if (userStore.user.processingMateGenerationTaskIds?.length) {
    userStore.user.processingMateGenerationTaskIds.forEach((taskId) => {
      pollMateGenerationTask(taskId);
    });
  }
};

onMounted(() => {
  const _lineMateCount = userStore.user.extraConfig?.lineMateCount;
  const _viewMode = userStore.user.extraConfig?.viewMode;

  if (_viewMode) {
    viewMode.value = _viewMode as "avatar" | "portrait";
  }

  if (_lineMateCount) {
    lineMateCount.value = _lineMateCount as number;
  }

  let width = document.body.clientWidth;
  if (width > 1024) width = 600;

  portraitPlaceholderHeight.value = (width / 3) * 4;
  initUserIfHasTask();
});

onActivated(() => {
  if (height.value) {
    scroller.value?.scrollTo(height.value);
  }
  initUserIfHasTask();
});
</script>
